/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ToastContainer } from "react-toastify";
import { FlexContainer } from "@nordcloud/gnui";
import { LoaderWrap } from "~/components/Loader";
import { useCustomer } from "~/context";
import { GlobalSwitch } from "~/routing/GlobalSwitch";
import { useAuth0 } from "~/services";
import { useSetupUserTracking } from "~/services/datadog/tracking";

export function App() {
  const { user, isLoading } = useAuth0();
  const { customer } = useCustomer();

  useSetupUserTracking({ ...user, customer });

  return (
    <LoaderWrap loading={isLoading}>
      <FlexContainer
        grow={1}
        css={{ minWidth: 0, maxWidth: "100%", width: "100%" }}
      >
        <GlobalSwitch />
        <ToastContainer />
      </FlexContainer>
    </LoaderWrap>
  );
}
